module.exports = __webpack_public_path__ + "static/img/1.f31c0c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/1.png
// module id = Xi5u
// module chunks = 0